import React from 'react';
import cx from 'classnames';
import {Flex, Text} from '@priority-software/priority-style-react';
import texts from '../texts';
import styles from '../styles/ToDoListConent.module.scss';
import {createDataTestId} from '../../../utils/dataTestId';

type ShowMoreRowProps = {
    openToDoListScreen: () => void;
    formName: string;
};

export const ShowMoreRow = ({openToDoListScreen, formName}: ShowMoreRowProps) => {
    const showMoreText: string = texts.view_more;
    const textParts: string[] = showMoreText.split(/([X])/g).filter(i => i);

    return (
        <Flex
            justifyContent="center"
            componentClasses={styles.showMoreRow}
            {...createDataTestId('TODOWidget-row-show-more', true)}
        >
            {textParts.map((part, i) => {
                switch (part) {
                    case 'X':
                        return (
                            <Text
                                skin="paragraph-2"
                                textColor="primary-500"
                                componentClasses={cx(styles.clickable, styles.underlined)}
                                onClick={openToDoListScreen}
                                key={i}
                            >
                                {part.replace('X', formName)}
                            </Text>
                        );
                    default:
                        return (
                            <Text skin="paragraph-2" textColor="primary-700" key={i}>
                                {part}
                            </Text>
                        );
                }
            })}
        </Flex>
    );
};
